export const GET_APPLICATION_STATUS_DEF = "/ApplicationStatusDef/GetAllApplicationStatusDef"